import { Context } from '@nuxt/types'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

// Register GSAP plugins globally
gsap.registerPlugin(ScrollToPlugin)

const gsapContext = (cb: () => void) => gsap.context(cb)

export { gsap, gsapContext }

export default (_: Context, inject: any) => {
  inject('gsap', gsap)
  inject('gsapContext', gsapContext)
}
